<button
  type="button"
  (click)="onAddClick()"
  class="flex items-center justify-center p-10 bg-white rounded-2xl shadow-xl h-64 sm:h-72 hover:bg-gray-50 hover:shadow-2xl transition-all duration-300 cursor-pointer w-full group animate-slide-up focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2"
  aria-label="Add new item">
  
  <svg 
    class="w-20 h-20 sm:w-24 sm:h-24 transition-all duration-300 group-hover:scale-110 group-hover:rotate-90" 
    viewBox="0 0 100 101" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50.0376" r="49" stroke="#E8E8E8" stroke-width="2" class="group-hover:stroke-primary-400 transition-colors duration-300"/>
    <path d="M29.1666 50.0376H70.8333" stroke="#E8E8E8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="group-hover:stroke-primary-400 transition-colors duration-300"/>
    <path d="M50 29.2041V70.8708" stroke="#E8E8E8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="group-hover:stroke-primary-400 transition-colors duration-300"/>
  </svg>
</button>
